const LINKS = [
  { id: "journey", label: "Journey" },
  { id: "itinerary", label: "Ceremonies" },
  { id: "venue", label: "Venue" },
  { id: "rsvp", label: "RSVP" },
];

export default function Nav() {
  const toTop = (e) => {
    e?.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleJump = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const linkClass = "text-rani font-semibold transition-colors hover:text-rani-deep whitespace-nowrap";

  return (
    <div id="top" className="relative z-20 edge py-3 md:py-3.5 bg-ivory">
      <div className="flex items-center justify-between">
        <a
          href="#top"
          onClick={toTop}
          className="block"
          aria-label="Back to top"
        >
          <img src="/brand/logo.png" alt="Sonakshi & Shubham" className="h-9 md:h-10 w-auto" />
        </a>

        <nav className="hidden md:flex gap-7 text-[11px] tracking-widest uppercase">
          <a href="#top" onClick={toTop} className={linkClass}>Home</a>
          {LINKS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleJump(e, item.id)}
              className={linkClass}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="text-[10px] tracking-chip uppercase text-rani font-medium">
          20.11.26 to 22.11.26
        </div>
      </div>

      <nav className="md:hidden flex gap-6 overflow-x-auto text-[10px] tracking-widest uppercase mt-2">
        <a href="#top" onClick={toTop} className={linkClass}>Home</a>
        {LINKS.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            onClick={(e) => handleJump(e, item.id)}
            className={linkClass}
          >
            {item.label}
          </a>
        ))}
      </nav>
      {/* Gold hairline that fades out at both ends */}
      <div
        className="absolute left-0 right-0 bottom-0 h-px pointer-events-none"
        style={{ background: "linear-gradient(90deg, rgba(201,169,97,0) 0%, rgba(201,169,97,0.55) 50%, rgba(201,169,97,0) 100%)" }}
      />
    </div>
  );
}
